import ProjectBox from "./ProjectsBox";

function Projects() {
	return (
		<section className="s1">
			<div className="main-container">
				<h3 style={{ textAlign: "center" }}>Some of my projects</h3>
				<div className="post-wrapper">
					<ProjectBox
						projectLink={
							"https://github.com/adityabhattad2021/Portfolio-dApp"
						}
						projectName={"A Ethereum Portfolio App"}
						projectDescription={
							"Build using Reactjs, Moralis EVM Api, Express know be used to instantly get ethereum wallet available token and NFT balances."
						}
					/>
					<ProjectBox
						projectLink={
							"https://github.com/adityabhattad2021/NFT-Marketplace-with-the-graph"
						}
						projectName={"NFT Marketplace"}
						projectDescription={
							"A fully functional NFT marketplace made using Nextjs, Solidity, Tailwindcss, Thegraphprotocal and Ethersjs Web3UIKit and hardhat."
						}
					/>
					<ProjectBox
						projectLink={
							"https://github.com/adityabhattad2021/Full-onchain-random-nft"
						}
						projectName={"Random NFTs"}
						projectDescription={
							"Fully on chain generated random NFTs made using Chainlink VRF."
						}
					/>
					<ProjectBox
						projectLink={
							"https://github.com/adityabhattad2021/Lottery-Nextjs-Frontend"
						}
						projectName={"Decentralized Lottery Dapp"}
						projectDescription={
							"A fully decentralized lottery made using NextJS Solidity Chainlink Moralis web3uikit Ethers Hardhat."
						}
					/>
					<ProjectBox
						projectLink={
							"https://github.com/adityabhattad2021/A-Basic-Implementation-of-DAO"
						}
						projectName={"Decentralized Autonomus Organisation"}
						projectDescription={
							"Basic Implementation of Decentralized Autonomus Orginizations (created using Openzeppelin Contracts)"
						}
					/>
					<ProjectBox 
						projectLink={"https://github.com/adityabhattad2021/Decentralized-Voting"}
						projectName={"Decentralized Voting System"}
						projectDescription={"This application is a 100% transparent voting system, which is fully secured by blockchain's immutable nature and is impossible to tamper with."}
						/>

					<ProjectBox
						projectLink={
							"https://github.com/adityabhattad2021/Fullstack-web3-crowd-funding-application"
						}
						projectName={"Crowd Funding Application with web3 stack"}
						projectDescription={
							"This application allows users to create and contribute to crowdfunding campaigns with gasless transections."
						}
					/>
					<ProjectBox
						projectLink={
							"https://devfolio.co/projects/deduplication-layer-on-filecoin-4bb1"
						}
						projectName={"Deduplication layer on Filecoin"}
						projectDescription={
							"A storage solution build on top of filecoin virtual machine to reduce cost of storing files on IPFS."
						}
					/>
					<ProjectBox
						projectLink={
							"https://github.com/adityabhattad2021/"
						}
						projectName={"An Awesome Project"}
						projectDescription={
							"Work in progress..."
						}
					/>
				</div>
			</div>
		</section>
	);
}

export default Projects;
